import { Component } from '@angular/core';

@Component({
  selector: 'app-ac-icon-arrow-right',
  templateUrl: './ac-icon-arrow-right.component.html',
  styleUrls: ['./ac-icon-arrow-right.component.scss']
})
export class AcIconArrowRightComponent {

}
